import React, { useEffect, useState } from "react";
import { Button, Form, Input, Select, message } from "antd";
import { collection, doc, onSnapshot, query, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase/config";
import { useAuthContext } from "../../../../hooks/useAuthContext";

const { TextArea } = Input;

export default function TapeOrderFillForm({ order, setOpen }) {
  const { user } = useAuthContext();
  const [allPlates, setAllPlates] = useState([]);
  const [selectedPlate, setSelectedPlate] = useState({ code: "none" });
  const [productsLoading, setProductsLoading] = useState(false);
  const [orderLoading, setOrderLoading] = useState(false);

  const [form] = Form.useForm();

  //gets the plate
  useEffect(() => {
    setProductsLoading(true);

    let ref = collection(db, "tapePlatesList");
    const q = query(ref);
    const unsubscribe = onSnapshot(q, (snapshot) => {
      let results = [];
      snapshot.docs.forEach((doc) => {
        results.push({ ...doc.data(), id: doc.id });
      });
      //sets the product with filter
      setAllPlates(results);
      setProductsLoading(false);
      console.log(results);
    });
    return () => unsubscribe();
  }, []);

  const onFinish = (values) => {
    console.log("Success:", values);
    updateOrder(values, 2);
    setOpen(false);
    setSelectedPlate({ code: "none" });
    form.resetFields();
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  //update order
  const updateOrder = async (object, orderStatus) => {
    setOrderLoading(true);
    const orderRef = doc(db, "orders", order.id);
    try {
      await updateDoc(orderRef, {
        technicalPage: order.selectedProduct.technicalPage, //takes the technical page from the order itself
        orderName: object.orderName,
        designerComment: object.designerComment,
        selectedPlate: selectedPlate,
        updatedBy: user.uid,
        updatedByEmail: user.email,
        updated: serverTimestamp(),
        orderForAdmin: false,
        orderReviewFromAdmin: false,
        orderStatus: orderStatus,
        changesByDesigner: null, //changes made by designer
        changedByDesigner: true,
      }).then(() => {
        message.success("updated!");
      });
    } catch (error) {
      message.error("Something went wrong");
      console.log(error);
    } finally {
      setOrderLoading(false);
    }
  };

  //plate select
  const handlePlateSelect = (value, option) => {
    const selectedPlate = allPlates.find((plate) => plate.id === value);
    setSelectedPlate(selectedPlate || { code: "none" });
  };
  return (
    <>
      <Form
        form={form}
        name="basic"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        style={{
          width: "100%",
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="Select Plate"
          name="selectedPlates"
          rules={[
            {
              required: true,
              message: "Please input your username!",
            },
          ]}
        >
          <Select
            value={selectedPlate.code}
            onChange={(value, option) => handlePlateSelect(value, option)}
            loading={productsLoading}
            options={allPlates.map((plate) => ({ value: plate.id, label: plate.code }))}
          />
        </Form.Item>

        <Form.Item
          label="Custom Order Name"
          name="orderName"
          rules={[
            {
              required: true,
              message: "Please input your username!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Designer Comment"
          name="designerComment"
          rules={[
            {
              required: true,
              message: "Please input your username!",
            },
          ]}
        >
          <TextArea />
        </Form.Item>

        <Form.Item>
          <Button block type="primary" loading={orderLoading} htmlType="submit">
            Update & Send
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
